import React from 'react'
import ModalWrapper from '../ModalWrapper'
import ConfirmUpdateGoogleContainer from '../../../containers/modals/account/ConfirmUpdateGoogleContainer'

const ConfirmUpdateGoogleModal= props => {


	return (
		<div className='accountAuthentication-modal'>
			<ModalWrapper
				{...props}
				title={'Change Google Account'}
				iconName='googleLogo'
				modalStyle='light'
				closeBtn={false}
			>
			<ConfirmUpdateGoogleContainer {...props} />
	</ModalWrapper>
	</div>
	)
}

export default ConfirmUpdateGoogleModal


// WEBPACK FOOTER //
// ./src/components/modals/account/ConfirmUpdateGoogleModal.js